import { 
    apiBizGetHouseStatus,
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_filter_query: 'todoListGraph/set_filter_query',
    set_district_house_uid: 'todoListGraph/set_district_house_uid',
    set_house: 'todoListGraph/set_house',
    set_loading: 'todoListGraph/set_loading'
}

// count state 必須是 Object
const state = {
    filterQuery: {
        group: null,
        member: null,
        empty: ['0','1'],
        status: ['0','1','2','3','4','5'],
        leaseTerm: [],
        houseType: '',
        buildingType: '',
        rent: [0, 100000],
    },
    houseResult: [],
    districtHouseUid: '',
    defaultFilterStatus: [0,1,2,3,4,5],
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    BIZ_TODO_LIST_GRAPH_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    BIZ_TODO_LIST_GRAPH_FILTER_RESULT: (state) => {
        return state.filterResult
    },
    BIZ_TODO_LIST_GRAPH_HOUSE_RESULT: (state) => {
        return state.houseResult
    },
    BIZ_TODO_LIST_GRAPH_DISTRICT_HOUSE_UID: (state) => {
        return state.districtHouseUid
    },
    BIZ_TODO_LIST_GRAPH_HOUSE_STATUS_LOADING: (state) => {
        return state.isLoading
    },
    BIZ_TODO_LIST_GRAPH_DEFAULT_FILTER_STATUS: (state) => {
        return state.defaultFilterStatus
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizTodoListGraph ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            apiBizGetHouseStatus()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.location
                    commit(types.set_house, value);
                    commit(types.set_loading, false);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            resolve()
        })
    },
    setBizTodoListGraphFilter ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            if(value != ''){
                commit(types.set_filter_query, value);
            }
            resolve()
        })
    },
    setBizTodoListGraphDistrictHouseUid( {commit} , value ) {
        return new Promise((resolve, reject) => {
            if(value != ''){
                commit(types.set_district_house_uid, value);
            }
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_filter_query](state, query){
        state.filterQuery = query
    },
    [types.set_district_house_uid](state, uid){
        state.districtHouseUid = uid
    },
    [types.set_house](state, data){
        state.houseResult = data
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/personalHome/todoListGraph.js